export function mapReluxDownloads(payload) {
	if (payload.code && payload.code === 'ERR_BAD_RESPONSE') {
		return null;
	} else {
		return Object.entries(payload)
			.map(([key, value]) => ({type: key, url: value.url}))
			.filter(item => item.url);
	}
}
